// since we are requiring the top level of faker, load all locales by default
var Faker = require('./lib');
var faker = new Faker({ locales: require('./lib/locales') });
module['exports'] = faker;


/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/index.js
 ** module id = 303
 ** module chunks = 0
 **/